module.exports = __webpack_public_path__ + "img/产品中心-产品背景图2.b9e3ee87.png";